import { render, staticRenderFns } from "./stuMaterialAnalysis.vue?vue&type=template&id=511c1cd7&scoped=true&"
import script from "./stuMaterialAnalysis.vue?vue&type=script&lang=js&"
export * from "./stuMaterialAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./stuMaterialAnalysis.vue?vue&type=style&index=0&id=511c1cd7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c1cd7",
  null
  
)

export default component.exports